import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output} from '@angular/core';
import {AppUIParams} from '../../app.ui-params';
import {
  CategorySkill, getCategorySkills,
  getLabelCategory,
  getSkillCategories, getSkillLabel,
  getSkillLevels,
  ProfessionalSkillModel,
  SkillModel
} from '../../../../../functions/src/data';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {LanguageService} from '../../../core/language/language.service';
import {SnackBarService} from '../snack-bar/snack-bar.service';

@Component({
  selector: 'app-add-skill-form',
  templateUrl: './add-skill.component.html',
  styleUrls: ['./add-skill.component.scss']
})
export class AddSkillComponent implements OnInit {

  @Input() listSkills: ProfessionalSkillModel[];
  @Input() withLevel = true;
  @Output() skillToAdd = new EventEmitter<ProfessionalSkillModel>();

  // Data
  categories: CategorySkill[];
  categorySkills: SkillModel[];
  skillLevels: string[];

  // Placeholders
  labelCategories: string;
  labelSkills: string;
  labelLevels: string;

  // Form controllers
  form: FormGroup;
  categoryFormControl: FormControl;
  categorySkillsFormControl: FormControl;
  skillLevelsFormControl: FormControl;

  // UI
  categoryIconColor: string;

  constructor(@Inject(LOCALE_ID) protected localeId: string,
              private formBuilder: FormBuilder,
              private language: LanguageService,
              private snackBar: SnackBarService) {
  }

  ngOnInit() {
    // Initialize form
    this.initForm();

    // Init Labels
    this.labelCategories = this.language.getLanguage().PROFESSIONAL_PROFILE_LABEL_CATEGORY;
    this.labelSkills = this.language.getLanguage().PROFESSIONAL_PROFILE_LABEL_SKILL;
    this.labelLevels = this.language.getLanguage().PROFESSIONAL_PROFILE_LABEL_SKILL_LEVEL;

    // Init Data
    this.categories = getSkillCategories();
    this.categorySkills = [];
    this.skillLevels = getSkillLevels();

    this.categoryIconColor = AppUIParams.actionButtonOrangeBackgroundColor;

  }

  /**
   * Initialize Form to add a new skill
   */
  private initForm() {

    // Init Form control
    this.categoryFormControl = new FormControl('', Validators.required);
    this.categorySkillsFormControl = new FormControl('', Validators.required);
    this.skillLevelsFormControl = this.withLevel ? new FormControl('', Validators.required) : null;

    // Init Form
    this.form = this.formBuilder.group({
      category: this.categoryFormControl,
      skill: this.categorySkillsFormControl,
      level: this.skillLevelsFormControl
    });
    this.form.valueChanges.subscribe(val => {
      this.onFormChanges(val);
    });

    this.categoryFormControl.valueChanges.subscribe(value => {
      // Reset skill selection when the category change
      this.categorySkillsFormControl.reset();
      this.skillLevelsFormControl.reset();
    });
  }

  /**
   * Verify if the skill should be enabled
   */
  isSkillEnabled(skill: SkillModel) {
    // Check if the skill was already selected
    if (this.listSkills) {
      for (const selectedSkill of this.listSkills) {
        if (selectedSkill.skill.id === skill.id && selectedSkill.skill.categoryId === skill.categoryId) {
          return false;
        }
      }
    }
    return true;
  }

  /**
   * Get Label of category
   */
  getCategoryLabel(category: CategorySkill) {
    if (category) {
      return getLabelCategory(category.id, this.localeId);
    } else {
      return '';
    }
  }

  /**
   * Get Label of a skill
   */
  getSkillLabel(skill: SkillModel) {
    if (skill) {
      return getSkillLabel(skill.id, this.localeId);
    } else {
      return '';
    }
  }

  onFormChanges(changes) {
    // Update Skills list
    if (changes.category) {
      this.categorySkills = getCategorySkills(changes.category.id);
    }
  }

  onAddClick() {
    console.log('onAddClick');
    // Add Skill
    if (this.form.valid) {
      this.skillToAdd.emit({
        category: this.categoryFormControl.value,
        skill: this.categorySkillsFormControl.value,
        skillLevel: this.skillLevelsFormControl ? this.skillLevelsFormControl.value : 5
      });
      this.form.reset();
    } else {
      // Alert the form is not valid
      this.snackBar.displayMessage(this.language.getLanguage().ERROR_FORM_INVALID);
      this.form.markAsTouched();
    }
  }
}
